/// <amd-module name="Build/Admin/PoolsList/Stores/AgentPoolStatusStore" />
import { Store } from "VSS/Reflux/Store";

import { TaskAgentPoolStatus } from "DistributedTask/Client/Contracts/TaskAgent";

export class AgentPoolStatusStore extends Store {
    public state: { [key: number]: TaskAgentPoolStatus } = {};

    constructor() {
        super("AgentPoolStatusStoreChanged");
    }

    public updateAgentPoolStatus = (poolId: number, agentPoolStatus: TaskAgentPoolStatus) => {
        const newState = {...this.state};
        newState[poolId] = agentPoolStatus;
        this.state = newState;
        this.emitChanged();
    }

    public updateAgentPoolStatuses = (agentPoolStatuses: TaskAgentPoolStatus[]) => {
        const statusMap: { [key: number]: TaskAgentPoolStatus } = {};
        agentPoolStatuses.forEach(status => {
            statusMap[status.id] = status;
        });
        this.state = statusMap;
        this.emitChanged();
    }
}
